import classNames from 'classnames';
import React from 'react';

import Heading from '@jpp/atoms/Heading';
import ProductCard from '@jpp/molecules/ProductCard';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';
import { IPdpStoreState } from 'common/redux/pdp/reducer';
import { ETheme } from 'common/typings/enums';
import { EProductStock } from 'common/typings/enums/product';

import './UpSell.scss';

export interface IUpSellProps {
  className?: string;
  heading?: string;
  theme?: ETheme;
  shouldHideOOSItems?: boolean;
  products?: IPdpStoreState[];
}

export interface IStoreUpSellProps {
  defaultProducts: IPdpStoreState[];
}

type TUpSell = IUpSellProps & IStoreUpSellProps;

const ROOT_CLASSNAME = 'UpSell';

const UpSell: React.FunctionComponent<TUpSell> = ({
  className,
  defaultProducts,
  shouldHideOOSItems = false,
  products,
  heading,
  theme,
}) => {
  const upsellProducts = products || defaultProducts;
  const hasAcf = upsellProducts.some((prod) => prod.acf || prod.acf_fields);
  const areProductsInStock = upsellProducts.some(
    (prod) => prod.stock_status === EProductStock.InStock
  );

  if (!upsellProducts || !hasAcf || !areProductsInStock) {
    return null;
  }

  return (
    <Section className={classNames(ROOT_CLASSNAME, className)} theme={theme}>
      <Container>
        <Row>
          <Flex col={12}>
            <Heading
              priority={2}
              className={`${ROOT_CLASSNAME}__heading`}
              children={heading || 'You may also like:'}
            />
          </Flex>
        </Row>

        <Row className="justify-content-center">
          {upsellProducts &&
            upsellProducts.map((product, index) => {
              if (
                shouldHideOOSItems &&
                product.stock_status !== EProductStock.InStock
              ) {
                return null;
              }

              return (
                <Flex
                  colLg={4}
                  colMd={6}
                  col={12}
                  key={`${product.sku}${index}`}
                  className={`${ROOT_CLASSNAME}__card`}
                >
                  <ProductCard pdp={product} bodyOverflow={false} />
                </Flex>
              );
            })}
        </Row>
      </Container>
    </Section>
  );
};

export default UpSell;
